
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  store,
  StoreMutations,
  StoreActions,
  FiltriLavorazioni
} from '@/store';
import { ItemDatiLookup } from '../models';
import { FilterCampionarioProduzione } from '@/models';

@Component
export default class OpzioniLavorazioni extends Vue {
  @Watch('$store.state.ui.opzioniVisibili')
  onOpzioniOpened(isOpenNew: boolean, isOpenOld: any) {
    if (isOpenNew && isOpenNew != isOpenOld) {
      // caricamento filtro corrente
      this.soloUSA = store.state.uiLavorazioni.filtri.soloUSA;
      this.soloConNote = store.state.uiLavorazioni.filtri.soloConNote;
      this.campionarioProduzione = store.state.uiLavorazioni.filtri.campionarioEProduzione;
      this.filtroNumOrdine = store.state.uiLavorazioni.filtri.numOrdine;
      this.filtroCodLAK = store.state.uiLavorazioni.filtri.codLAK;
      this.filtroLotto = store.state.uiLavorazioni.filtri.lotto;
      this.filtroModelli = store.state.uiLavorazioni.filtri.filtroModelli;
      this.filtroStagioni = store.state.uiLavorazioni.filtri.filtroStagioni;
      this.filtroFasi = store.state.uiLavorazioni.filtri.filtroFasi;
      this.filtroConsegne =
        store.state.uiLavorazioni.filtri.filtroConsegne || [];
    }
  }

  soloUSA: boolean = false;
  soloConNote: boolean = false;
  campionarioProduzione: any = {
      label:"Campionario e produzione",
      value: FilterCampionarioProduzione.CampionarioEProduzione
    };
  filtroNumOrdine: string = '';
  filtroCodLAK: string = '';
  filtroLotto: string = '';

  searchModello: string = '';
  filtroModelli: string[] = [];
  searchStagione: string = '';
  filtroStagioni: string[] = [];
  searchFase: string = '';
  filtroFasi: string[] = [];
  searchConsegna: string = '';
  filtroConsegne: string[] = [];

  opzioniCampionarioProduzione: any = [
    {
      label:"Campionario e produzione",
      value: FilterCampionarioProduzione.CampionarioEProduzione
    },
    {
      label:"Solo produzione",
      value: FilterCampionarioProduzione.SoloProduzione
    },
    {
      label:"Solo campionario",
      value: FilterCampionarioProduzione.SoloCampionario
    }
  ]

  get modelliFiltrati(): ItemDatiLookup[] {
    if(store.state.datiLookup && store.state.datiLookup.modelli) {
      return store.state.datiLookup.modelli.filter((e:ItemDatiLookup) => (e.desc || '')
        .toLowerCase()
        .indexOf((this.searchModello || '').toLowerCase()) > -1
      );
    }
    return [];
  }

  get stagioniFiltrate(): ItemDatiLookup[] {
    if(store.state.datiLookup && store.state.datiLookup.stagioni) {
      return store.state.datiLookup.stagioni.filter((e:ItemDatiLookup) => (e.desc || '')
        .toLowerCase()
        .indexOf((this.searchStagione || '').toLowerCase()) > -1
      );
    }
    return [];
  }

  get fasiFiltrate(): ItemDatiLookup[] {
    if(store.state.datiLookup && store.state.datiLookup.fasi) {
      return store.state.datiLookup.fasi.filter((e:ItemDatiLookup) => (e.desc || '')
        .toLowerCase()
        .indexOf((this.searchFase || '').toLowerCase()) >-1
      );
    }
    return [];
  }

  get consegneFiltrate(): ItemDatiLookup[] {
    if(store.state.datiLookup && store.state.datiLookup.consegne) {
      return store.state.datiLookup.consegne.filter((e:ItemDatiLookup) => (e.desc || '')
        .toLowerCase()
        .indexOf((this.searchConsegna || '').toLowerCase()) > -1
      );
    }
    return [];
  }

  private annullaModificaFiltro() {
    store.commit(StoreMutations.SetOpzioniVisibili, false);
  }

  private applicaModificaFiltro() {
    // TODO
    let filtri: FiltriLavorazioni = {
      mostraCompletati: false,
      soloUSA: this.soloUSA,
      soloConNote: this.soloConNote,
      campionarioEProduzione: this.campionarioProduzione,
      numOrdine: this.filtroNumOrdine,
      codLAK: this.filtroCodLAK,
      lotto: this.filtroLotto,
      filtroModelli: this.filtroModelli,
      filtroStagioni: this.filtroStagioni,
      filtroFasi: this.filtroFasi,
      filtroConsegne: this.filtroConsegne
    };
    store.commit(StoreMutations.SetFiltriLavorazioni, filtri);
    store.commit(StoreMutations.SetOpzioniVisibili, false);
  }

  private svuotaFiltro() {
    this.soloUSA = false;
    this.soloConNote = false;
    this.campionarioProduzione = FilterCampionarioProduzione.CampionarioEProduzione;
    this.filtroNumOrdine = '';
    this.filtroCodLAK = '';
    this.filtroLotto = '';
    this.filtroModelli = [];
    this.filtroStagioni = [];
    this.filtroFasi = [];
    this.filtroConsegne = [];
  }
}
